const getMessageFromCodeOrContent = (errorCode, customContent) => {
  if (customContent) {
    return customContent;
  }
  switch (errorCode) {
    case 'auth/user-not-found':
      return 'Aucun utilisateur ne correspond à cet identifiant.<br/><br/>' +
        'Si vous n\'avez pas encore de compte, cliquez sur <em>"Création de compte"</em> sous le' +
        ' formulaire de connexion.';
    case 'auth/wrong-password':
      return 'Mot de passe incorrect.<br/><br/>' +
        'Si vous avez perdu votre mot de passe, cliquez sur <em>"Mot de passe perdu"</em> sous le' +
        ' formulaire de connexion.';
    case 'auth/email-already-in-use':
      return 'Il existe déjà un compte pour cette adresse email.<br/><br/>' +
        'Si vous avez perdu votre mot de passe, cliquez sur <em>"Mot de passe perdu"</em> sous le' +
        ' formulaire de connexion.';
    case 'auth/network-request-failed':
      return 'Problème réseau : vérifiez votre connexion internet.';
    case 'auth/password-required':
      return 'Vous devez saisir un mot de passe.';
    case 'auth/missing-password-confirmation':
      return 'Vous devez saisir une seconde fois le mot de passe choisi.';
    case 'auth/weak-password':
      return 'Le mot de passe ne répond pas aux exigences de sécurité !';
    case 'auth/passwords-mismatch':
      return 'Les deux mots de passe saisis ne sont pas identifiques.<br>' +
        'Veuillez vérifier votre saisie';
    case 'auth/invalid-email':
      return 'Vous devez saisir une adresse email valide.';
    default:
      console.warn('errorCode inconnu : ', errorCode);
      return 'Erreur inconnue';
  }
};

export const setAlertMsg = (errorCode, title, customContent, type) => ({
  alert: {
    header: title,
    content: getMessageFromCodeOrContent(errorCode, customContent),
    open: true,
    type: type || (errorCode ? 'error' : null),
  },
  confirm: {
    open: false,
  },
  pick: {
    open: false,
  },
});

export const askConfirmation = (title, customContent, type, callback, buttonText) => ({
  confirm: {
    header: title,
    content: customContent,
    action: callback,
    open: true,
    type,
    buttonText,
  },
  alert: {
    open: false,
  },
  pick: {
    open: false,
  },
});

export const pickOne = (title, customContent, type, callback, listToSelectFrom, buttonText, placeholder) => ({
  pick: {
    header: title,
    content: customContent,
    action: callback,
    options: listToSelectFrom,
    placeholder,
    open: true,
    type,
    buttonText,
  },
  alert: {
    open: false,
  },
  confirm: {
    open: false,
  },
});



// WEBPACK FOOTER //
// ./src/components/Modals/helpers.js